import { render } from "./QwilrDefinitionBlock.vue?vue&type=template&id=68f7a9ca"
import script from "./QwilrDefinitionBlock.vue?vue&type=script&lang=js"
export * from "./QwilrDefinitionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__